import createVueComponent from '../createVueComponent';
export default createVueComponent('route-alt-left', 'IconRouteAltLeft', [
  ['path', { d: 'M8 3h-5v5', key: 'svg-0' }],
  ['path', { d: 'M16 3h5v5', key: 'svg-1' }],
  ['path', { d: 'M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93', key: 'svg-2' }],
  ['path', { d: 'M18 6.01v-.01', key: 'svg-3' }],
  ['path', { d: 'M16 8.02v-.01', key: 'svg-4' }],
  ['path', { d: 'M14 10v.01', key: 'svg-5' }],
]);
